import React from 'react';
import { View } from 'react-native';
import { WorkoutListCard } from './structured-parts/WorkoutListCard';
import { GenericTableCard } from './structured-parts/GenericTableCard';
import { WorkoutCard } from './structured-parts/WorkoutCard';
import { WorkoutSupersetCard } from './structured-parts/WorkoutSupersetCard';
import { WorkoutExerciseCard } from './structured-parts/WorkoutExerciseCard';
import { SportActivityCard } from './structured-parts/SportActivityCard';
import { MealCard } from './structured-parts/MealCard';
import { MealLogCard } from './structured-parts/MealLogCard';
import { MealLogListCard } from './structured-parts/MealLogListCard';

export interface StructuredPartRendererProps {
  kind: string;
  payload: Record<string, unknown>;
}

const renderCard = (kind: string, payload: Record<string, unknown>) => {
  switch (kind) {
    case 'workout_list':
      return <WorkoutListCard payload={payload} />;
    case 'workout':
      return <WorkoutCard.Synced payload={payload} />;
    case 'workout_superset':
      return <WorkoutSupersetCard.Synced payload={payload} />;
    case 'workout_exercise':
      return <WorkoutExerciseCard.Synced payload={payload} />;
    case 'sport_activity':
      return <SportActivityCard.Synced payload={payload} />;
    case 'meal':
      return <MealCard.Synced payload={payload} />;
    case 'meal_log':
      return <MealLogCard.Synced payload={payload} />;
    case 'meal_log_list':
      return <MealLogListCard payload={payload} />;
    case 'table':
      return <GenericTableCard payload={payload} />;
    default:
      // Unknown structured type - don't render anything
      return null;
  }
};

export const StructuredPartRenderer: React.FC<StructuredPartRendererProps> = ({
  kind,
  payload,
}) => {
  const card = renderCard(kind, payload);
  if (!card) {
    return null;
  }
  return <View className="w-full max-w-[500px]">{card}</View>;
};
